export default function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-hierarchy/src/treemap/dice.js
// module id = Z1AK
// module chunks = 0